import { Component, inject, OnInit } from '@angular/core';

import { SessionService } from '../../../auth/services/session/session.service';
import { LayoutComponent } from '../../../shared/layouts/layout/layout.component';
import { CalendarComponent } from '../../components/calendar/calendar.component';
import { ServicesTableComponent } from '../../components/services-table/services-table.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    LayoutComponent,
    CalendarComponent,
    ServicesTableComponent,
    CommonModule,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  private _sessionService = inject(SessionService);

  public showCalendar: boolean = true;

  ngOnInit(): void {
    this.showCalendar = !!this._sessionService.Customer.show_calendar;
  }
}
